var _desc, _defs, _g, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.2.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 30 30)",
    id: "6c49a699-0011-4e77-96b3-b07d0a454d36"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -30,
    y: -30,
    rx: 0,
    ry: 0,
    width: 60,
    height: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e1606e5d-8a93-4eb5-b077-292362342f8d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3 0 0 0.3 30 30)",
    style: {},
    id: "645181f7-1e84-48e9-a3aa-7876873afa44"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    fontFamily: "Lato",
    fontSize: 40,
    fontStyle: "normal",
    fontWeight: 400,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1,
      whiteSpace: "pre"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -73.7,
    y: 12.57
  }, "CHARM")))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.33 0 0 0.33 45 46)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -14.31 14.48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(101,101,101)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-35.69, -64.48)",
    d: "M 42.531 43.218 L 17.319 68.373 C 13.363999999999999 72.328 13.363999999999999 78.809 17.319 82.76400000000001 C 20.615 86.06000000000002 25.612 86.60900000000001 29.458 84.46700000000001 L 29.458 77.87400000000001 L 34.455 77.87400000000001 L 34.455 68.70200000000001 L 43.903 68.70200000000001 L 43.903 64.47300000000001 L 49.341 64.47300000000001 L 49.341 59.03500000000001 L 55.493 59.03500000000001 L 57.029 57.49900000000001 C 53.73500000000001 56.45400000000001 50.550000000000004 54.58600000000001 47.912000000000006 51.95000000000001 C 45.387 49.424 43.574 46.402 42.531 43.218 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 14.93 -15.05)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(101,101,101)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.93, -34.95)",
    d: "M 79.551 20.313 C 71.475 12.241 58.349000000000004 12.241 50.274 20.313 C 42.202 28.387 42.202 41.516 50.274 49.589 C 58.349000000000004 57.663 71.475 57.663 79.551 49.589 C 87.68 41.515 87.68 28.387 79.551 20.313 z M 75.267 32.671 C 73.068 34.924 69.443 34.924 67.191 32.671 C 64.99600000000001 30.474 64.99600000000001 26.85 67.191 24.599 C 69.443 22.4 73.068 22.4 75.267 24.599 C 77.519 26.85 77.519 30.474 75.267 32.671 z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharm);
export default __webpack_public_path__ + "static/media/charm.cb3981e4.svg";
export { ForwardRef as ReactComponent };